import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { Then } from "./IfThenElse";

interface ThenContainerProps {
    positiveCondition: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: ThenContainerProps) => ({
    visible: ownProps.processEvaluableProp(state, ownProps.positiveCondition),
});

export const ThenContainer = withResolvePaths(withViewModelSelect(withEvaluators(connect(mapStateToProps)(Then))));
